<template>
	<div class="zoom-controls" :class="isMetro ? 'separator-left' : ''" data-tour-item="zoom">
		<div class="zoom-group" >

			<button v-tooltip="{ content: content.zoomOut }" :aria-label="content.zoomOut"
				:disabled="currentZoom === zoomMin" class="zoom-out" tabindex="0" @click="zoomOutComponent">
				<svg role="img" viewBox="258.5786 204.5633 26 26" width="16" height="16" xmlns="http://www.w3.org/2000/svg" aria-labelledby="zoomOut">
					<title id="zoomOut">Zoom Out Icon</title>
					<g transform="matrix(1, 0, 0, 1, 17.262638092041016, -19.728729248046875)">
						<g>
							<ellipse
								style="fill: rgb(216, 216, 216); stroke: rgb(104, 163, 57); stroke-width: 0px; paint-order: stroke;"
								cx="254.316" cy="237.292" rx="13" ry="13" />
						</g>
						<path d="M 248.5 237.909 L 260.5 237.909" stroke-width="2" stroke-linecap="round"
							stroke-linejoin="round" style="fill: rgb(84, 84, 84); stroke: rgb(84, 84, 84);" />
					</g>
				</svg>
			</button>
			<!-- <div class="zoom-percent">{{ displayedZoomPercentage }}%</div> -->
			<span class="group-panel-label" tabindex="0" :aria-label="content.pageZoom">{{ content.pageZoom }}</span>
			<button v-tooltip="{ content: content.zoomIn }" :aria-label="content.zoomIn" :disabled="currentZoom === zoomMax"
				class="zoom-in" tabindex="0" @click="zoomInComponent">
				<svg role="img" viewBox="231.452 178.053 26 26" width="16" height="16" xmlns="http://www.w3.org/2000/svg"
				aria-labelledby="zoomIn">
					<title id="zoomIn">Zoom In Icon</title>
					<g>
						<ellipse
							style="fill: rgb(216, 216, 216); stroke: rgb(104, 163, 57); stroke-width: 0; paint-order: stroke;"
							cx="244.452" cy="191.053" rx="13" ry="13" />
						<path d="M 238 191 L 250 191 M 244 185 L 244 197" stroke-width="2" stroke-linecap="round"
							stroke-linejoin="round" style="stroke: rgb(84, 84, 84);" />
					</g>
				</svg>
			</button>
			<button v-tooltip="{ content: content.resetZoom }" :aria-label="content.resetZoom" :disabled="currentZoom === 0"
				class="zoom-100" @click="zoomNormalComponent">
				<svg role="img" width="22px" height="16px" viewBox="0 0 22 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink" aria-labelledby="resetIcon">
					<title id="resetIcon">Reset Icon</title>
					<g id="Search-&amp;-Filter" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
						<g id="CT-Digital-CTC-Flyer---Vertical-Scrolling---FilteredSearch-Copy"
							transform="translate(-1442.000000, -32.000000)" fill="#545454" fill-rule="nonzero">
							<path
								d="M1460,36 L1456,40 L1459,40 C1459,43.31 1456.31,46 1453,46 C1451.99,46 1451.03,45.75 1450.2,45.3 L1448.74,46.76 C1449.97,47.54 1451.43,48 1453,48 C1457.42,48 1461,44.42 1461,40 L1464,40 L1460,36 Z M1447,40 C1447,36.69 1449.69,34 1453,34 C1454.01,34 1454.97,34.25 1455.8,34.7 L1457.26,33.24 C1456.03,32.46 1454.57,32 1453,32 C1448.58,32 1445,35.58 1445,40 L1442,40 L1446,44 L1450,40 L1447,40 Z"
								id="icon-reset"></path>
						</g>
					</g>
				</svg>
			</button>
		</div>
		<span class="panel-label">{{ content.pageZoom }}</span>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Lytics from "@/classes/Lytics";

export default {
	name: "ZoomControlsV2",
	computed: {
		...mapGetters(['content', 'isMetro']),
		...mapState('scale', ['zoomMin', 'zoomMax', 'zoomLevel']),
		currentZoom() {
			return this.zoomLevel;
		},
		displayedZoomPercentage() {
			return Math.round(100 + (this.currentZoom * 100));
		}
	},
	methods: {
		...mapActions('scale', ['zoomIn', 'zoomOut', 'zoomNormal', 'setManualZoom']),
		zoomInComponent() {
			this.setManualZoom(true)
			this.zoomIn();
			this.$emit('change', this.currentZoom);
			Lytics.TriggerZoom(true)
		},
		zoomOutComponent() {
			this.setManualZoom(true)
			this.zoomOut();
			this.$emit('change', this.currentZoom);
			Lytics.TriggerZoom(false)
		},
		zoomNormalComponent() {
			this.setManualZoom(true)
			this.zoomNormal();
			this.$emit('change', this.currentZoom);
		},
	}
}
</script>

<style lang="scss" scoped>
.control-panel-v2 .comp-list-item .zoom-controls {
    display: inline-flex;
    align-items: center;
    padding: 3px 5px;

	.zoom-group {
		display: flex;
		align-items: center;
		
		.zoom-in, .zoom-out {
			svg {
				width: 19px;
				height: 19px;
			}
			
		}
		button.zoom-100 {
		  margin-left: 10px;
		}
		.group-panel-label {
			display: unset;
			margin-right: 15px;
		}
	}
    .panel-label {
		display: none;
    }
}
.zoom-controls {

	&:hover {
		color: var(--secondary-color);

		.zoom-100 svg g path {
			fill: var(--secondary-color);
			stroke: none !important;
		}

		svg g path {
			stroke: var(--secondary-color) !important;
		}

		svg g ellipse {
			fill: var(--secondary-color) !important;
			opacity: 0.1 !important;
		}
	}

	.zoom-group {
		display: flex;
		justify-self: end;

		>* {
			background: none;
			border: 0;
			min-height: unset;
		}

		>button {
			border-radius: 0;
			min-width: 15px;

			&:disabled {
				opacity: 0.5;
				cursor: inherit;
				pointer-events: none;
			}
		}

		.zoom-in,
		.zoom-out {
			padding: 0;
			width: 20px;
			font-size: 0;
			line-height: 0;

			img {
				vertical-align: middle;
			}
		}
		.group-panel-label {
			display:none;
		}

	}

}</style>
